import { createContext } from 'react';
import createStateProvider from '../../../Shared/createStateProvider';
import {
  ConnectionThresholdState,
  ToInitialState,
  UseLegFilterState,
  UseAvailableConnectionThresholds,
} from './types';

const StateContext = createContext<ConnectionThresholdState>(null);

const toInitialState: ToInitialState = (availableConnectionThresholds) => {
  const getDefaults = (key: '' | 'TRAIN' | 'PLANE') =>
    availableConnectionThresholds &&
    availableConnectionThresholds[key] &&
    availableConnectionThresholds[key].map(({ defaultValue }) => defaultValue);

  return {
    '': getDefaults(''),
    TRAIN: getDefaults('TRAIN'),
    PLANE: getDefaults('PLANE'),
  };
};

const { StateProvider, useFilterState, useAvailableFilterState } =
  createStateProvider<ConnectionThresholdState>(
    'connectionThresholds',
    StateContext,
    toInitialState
  );

const useLegFilterState: UseLegFilterState = (legId, transportType) => {
  const availableConnectionThresholdsState = useFilterState();
  return availableConnectionThresholdsState?.[transportType]?.[legId] ?? null;
};

const useAvailableConnectionThresholds: UseAvailableConnectionThresholds = (
  legId,
  transportType
) => {
  const availableConnectionThresholdsState = useAvailableFilterState();
  return availableConnectionThresholdsState?.[transportType]?.[legId] ?? null;
};

export default StateProvider;

export {
  useAvailableFilterState,
  useFilterState,
  useLegFilterState,
  useAvailableConnectionThresholds,
};
